import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

import "./index.css";

import { PostHogProvider } from "posthog-js/react";

import { initSentry } from "./utils/sentry";

// Initialize Sentry before rendering the app
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: "https://ph-ingest.samphireneuro.com/ph/", // Use the separate proxy domain
        defaults: "2025-05-24",
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        // debug: import.meta.env.MODE === "development",
      }}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
